import { useTransportMileageFiltersStore } from 'shared/stores/use-transport-mileage-filters';
import { SearchFilter } from 'components/common/search-filter';

export const TransportMileageSearch = () => {
  const { setSearch } = useTransportMileageFiltersStore();

  return <SearchFilter setSearch={setSearch} />;
};
